<template>
    <v-autocomplete
            color="primary"
            hide-no-data
            v-model="rolesSelected"
            :clearable="!unclearable"
            :items="rolesItems"
            :loading="rolesLoading"
            :search-input.sync="rolesSearch"
            item-text="Description"
            item-value="id"
            item-disabled="disabled"
            :label="noLabel ? '' : label ? label : $t('SmsPushSetting.TableTitle.role')"
            return-object
            :single-line="singleLine"
            :dense="dense"
            :hide-details="hideDetails"
            :style="dense ? 'margin-left: auto; margin-right: auto' : ''"
    ></v-autocomplete>
</template>

<script>
import Roles from "@/api/roles";

export default {
    name: "SearcherRoles",

    props: {
        value: Object,
        rolesDistrict: Object,
        rolesDistricts: Array,
        noLabel: Boolean,
        label: String,
        singleLine: Boolean,
        dense: Boolean,
        hideDetails: Boolean,
        unclearable: Boolean,
        disabledItems: Array
    },

    computed: {
        rolesItems() {
            var roles;
            if (this.rolesDistrict) {
                roles = this.roles.filter(
                    (role) => role.id == this.rolesDistrict.id
                );
            } else {
                roles = this.roles;
            }
            roles = this.roles;
            return roles.map((role) => {
                const Description = role.role_name;
                const disabled = this.disabledItems
                    ? this.disabledItems.find(
                        (disabledItem) => disabledItem.id == role.id
                    )
                    : false;
                return Object.assign({}, role, {Description, disabled});
            });
        },
    },

    data: () => ({
        roles: [],
        rolesLoading: false,
        rolesSearch: "",
        rolesSelected: null,
    }),

    mounted() {
        this.rolesLoading = true;
        Roles.fetchAll().then(
            function (response) {
                if (response.data.status.isOK()) {
                    this.roles = response.data.roles;
                }
                this.rolesLoading = false;
            }.bind(this)
        )
            .catch(
                function () {
                    this.rolesLoading = false;
                }.bind(this)
            );
    },

    watch: {
        value: {
            immediate: true, //初始赋值也调用
            handler() {
                if (this.unclearable && !this.value && this.roles) {
                    this.rolesSelected = this.roles[0];
                } else {
                    this.rolesSelected = this.value;
                }
            },
        },

        rolesSelected: {
            handler() {
                this.$emit("input", this.rolesSelected);
            },
        },
    },
};
</script>